import moment from 'moment'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { logout } from '../store/authSlice'

function PrivateRoute({ children }) {
    const authen = useSelector((state) => state.auth)
    const accessToken = localStorage.getItem('AccessToken')
    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {

        if (authen.isAuthenticated && accessToken) {
            let now = moment().unix()
            if (authen?.user?.expire_datetime_in) {
                let expire = moment(authen?.user?.expire_datetime_in).unix()
                if (expire) {
                    let time = expire - now
                    if (time <= 0) {
                        console.log('token หมดอายุ')
                        localStorage.clear()
                        dispatch(logout())
                    }
                } else {
                    localStorage.clear()
                    dispatch(logout())
                }
            }



        } else {
            console.log('ไม่มี auth')
        }
    }, [])

    return (
        (authen.isAuthenticated && accessToken ? children : <Navigate to='/login' />)
    )
}

export default PrivateRoute
